<script setup>

import {useProductPageStore} from "~/stores/ProductPageStore";

const store = useProductPageStore();

function countByStar(i) {
    return store.ratingInfo['count_' + i] || 0;
}

function countByStarPercent(i) {
    const count = countByStar(i);
    if (count === 0) return 0;
    return (count / store.ratingInfo.count) * 100;
}


</script>

<template>
    <div class="mwp-550 mt-2">
        <div v-for="i in 5" :key="i" class="row align-items-center mt-1">
            <div class="col-1 fw-bold">
                {{ 6 - i }}
            </div>
            <div class="col-9 col-sm-8 col-md-9 col-lg-8 col-xl-9">
                <div class="rating-bar-container">
                    <div
                        class="bg-star-active"
                        :style="{ width: countByStarPercent(6 - i) + '%' }"
                    ></div>
                </div>
            </div>
            <div class="col-2 col-sm-1">
                ({{ countByStar(6 - i) }})
            </div>
        </div>
    </div>
</template>
